import React from 'react';

// Utils
import { SCHEMA_TYPE_MULTI_ENUM, SCHEMA_TYPE_TEXT, SCHEMA_TYPE_YOUTUBE } from '../../util/types';
import {
  isFieldForCategory,
  pickCategoryFields,
  pickCustomFieldProps,
} from '../../util/fieldHelpers.js';

import SectionDetailsMaybe from './Sections/SectionDetailsMaybe';
import SectionMultiEnumMaybe from './Sections/SectionMultiEnumMaybe';
import SectionTextMaybe from './Sections/SectionTextMaybe';
import SectionYoutubeVideoMaybe from './Sections/SectionYoutubeVideoMaybe';

/**
 * Renders custom listing fields.
 * - SectionDetailsMaybe is used if schemaType is 'enum', 'long', or 'boolean'
 * - SectionMultiEnumMaybe is used if schemaType is 'multi-enum'
 * - SectionTextMaybe is used if schemaType is 'text'
 *
 * @param {*} props include publicData, metadata, listingFieldConfigs, categoryConfiguration
 * @returns React.Fragment containing aforementioned components
 */
const CustomListingFields = props => {
  const { publicData, metadata, listingFieldConfigs, categoryConfiguration } = props;

  const { key: categoryPrefix, categories: listingCategoriesConfig } = categoryConfiguration;
  const categoriesObj = pickCategoryFields(publicData, categoryPrefix, 1, listingCategoriesConfig);
  const currentCategories = Object.values(categoriesObj);

  const isFieldForSelectedCategories = fieldConfig => {
    return isFieldForCategory(currentCategories, fieldConfig);
  };
  const propsForCustomFields =
    pickCustomFieldProps(
      publicData,
      metadata,
      listingFieldConfigs,
      'listingType',
      isFieldForSelectedCategories
    ) || [];

  const fieldsToHide = [
    'websiteUrl',
    'instagram',
    'facebook',
    'whatsappNumber',
    'vibesTag',
    'dropInAvailable',
    'gymType',
    'isBookableOnFootFall',
    'isMockData',
    'isIncludedWithMembership',
    'dropInPrice',
    'pricingDetails',
    'howToJoin',
    'howToPrepare',
  ];

  return (
    <>
      <SectionDetailsMaybe
        {...props}
        isFieldForCategory={isFieldForSelectedCategories}
        fieldsToHide={fieldsToHide}
      />
      {propsForCustomFields
        .filter(customFieldProps => !fieldsToHide.includes(customFieldProps.key))
        .map(customFieldProps => {
          const { schemaType, key, ...fieldProps } = customFieldProps;
          return schemaType === SCHEMA_TYPE_MULTI_ENUM ? (
            <SectionMultiEnumMaybe key={key} {...fieldProps} />
          ) : schemaType === SCHEMA_TYPE_TEXT ? (
            <SectionTextMaybe key={key} {...fieldProps} fieldName={key} />
          ) : schemaType === SCHEMA_TYPE_YOUTUBE ? (
            <SectionYoutubeVideoMaybe key={key} {...fieldProps} />
          ) : null;
        })}
    </>
  );
};

export default CustomListingFields;
